import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

interface NewsHighlightProps {
  items: NewsItem[];
}

export default function NewsHighlight({ items }: NewsHighlightProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
      {items.length > 0 && (
        <Link
          to={`/news/${items[0].id}`}
          className="group relative rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-primary-300 transition-colors block"
        >
          <div className="relative w-full h-56 md:h-72 overflow-hidden">
            <img
              src={items[0].image}
              alt={`${items[0].title} - 蘑菇TV资讯配图`}
              title={`${items[0].title} + 蘑菇TV资讯`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="inline-block px-2 py-0.5 rounded bg-primary-500 text-background-50 text-xs font-medium mb-2">
                {items[0].category}
              </span>
              <h3 className="font-heading font-bold text-base md:text-lg text-background-50 leading-snug line-clamp-2">
                {items[0].title}
              </h3>
              <p className="mt-1.5 text-xs text-background-200 flex items-center gap-1">
                <i className="ri-calendar-line"></i>
                {items[0].date}
              </p>
            </div>
          </div>
        </Link>
      )}

      <div className="flex flex-col gap-3">
        {items.slice(1, 6).map((item) => (
          <Link
            key={item.id}
            to={`/news/${item.id}`}
            className="group flex items-start gap-4 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 p-4 transition-colors"
          >
            <div className="w-24 h-20 md:w-28 md:h-20 shrink-0 rounded-md overflow-hidden bg-secondary-100">
              <img
                src={item.image}
                alt={`${item.title} - 蘑菇TV资讯配图`}
                title={`${item.title} + 蘑菇TV资讯`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="font-heading font-semibold text-sm text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-500 line-clamp-1">{item.summary}</p>
              <p className="mt-1.5 text-xs text-foreground-400 flex items-center gap-1">
                <i className="ri-time-line"></i>
                {item.date}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}